import * as Joi from 'joi';
import { AccountActivationData } from '../../../models';

const schemaAccountActivation = Joi.object<AccountActivationData>({
  username: Joi.string().required().messages({
    'string.empty': 'Username is not allowed to be empty',
    'any.required': 'Username is not allowed to be empty',
  }),
  dateOfBirth: Joi.date().max('2037-12-31').messages({
    'date.base': 'Date of birth not allowed to be empty.',
    'date.max': 'Start Date should not be greater than 31/12/2037',
  }),
  // dateOfBirth: Joi.custom((...joiParams) => validateDate(false, ...joiParams)).messages({
  //   'date.pattern.isEmpty': 'Date of birth is not allowed to be empty',
  //   'date.pattern.notValid': 'Date of birth must be a valid date',
  //   'date.pattern.isAfter': 'Date of birth cannot be of future dates',
  // }),
});

export default schemaAccountActivation;
